<template>
  <div>
    <el-form
      :inline="true"
      ref="formRef"
      :rules="rules"
      label-width="100px"
      :model="ruleForm"
      class="demo-form-inline"
      size="small"
    >
      <!-- 走访 -->
      <el-row v-if="from.dutyType === '1'">
        <el-col :span="24">
          <el-form-item label="关怀事务" prop="handleContent">
            <el-input
              type="textarea"
              v-model="ruleForm.handleContent"
              placeholder="关怀事务"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="走访时间" prop="handleTime">
            <el-date-picker
              v-model="ruleForm.handleTime"
              type="datetime"
              placeholder="走访时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="走访人员" prop="handler">
            <el-select v-model="ruleForm.handler" placeholder="走访人员">
              <el-option
                v-for="item in optionsYhList"
                :key="item.userId"
                :label="item.name"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="走访记录" prop="handleRecord">
            <el-input
              type="textarea"
              v-model="ruleForm.handleRecord"
              placeholder="走访记录"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="走访图片" prop="search">
            <el-upload
              :action="'/api/hz-smart-community/sys/file/upload'"
              list-type="picture-card"
              :headers="{
                token: token,
              }"
              :show-file-list="false"
              :on-success="handlePictureCardPreview"
              :limit="1"
            >
              <el-icon v-if="!ruleForm.imageUrl"><plus /></el-icon>
              <img v-else :src="imgURL + ruleForm.imageUrl" />
            </el-upload>
          </el-form-item>
        </el-col>
        <div class="form-button">
          <el-button type="primary" @click="onSubmit(formRef)">提交</el-button>
          <el-button @click="cancel">返回</el-button>
        </div>
      </el-row>
      <!-- 电话 -->
      <el-row v-else>
        <el-col :span="24">
          <el-form-item label="关怀事务" prop="handleContent">
            <el-input
              type="textarea"
              v-model="ruleForm.handleContent"
              placeholder="关怀事务"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="通话时间" prop="handleTime">
            <el-date-picker
              v-model="ruleForm.handleTime"
              type="datetime"
              placeholder="通话时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="通话人员" prop="handler">
            <el-select v-model="ruleForm.handler" placeholder="通话人员">
              <el-option
                v-for="item in optionsYhList"
                :key="item.userId"
                :label="item.deptName + '__' + item.name"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="沟通记录" prop="handleRecord">
            <el-input
              type="textarea"
              v-model="ruleForm.handleRecord"
              placeholder="沟通记录"
            ></el-input>
          </el-form-item>
        </el-col>
        <div class="form-button">
          <el-button type="primary" @click="onSubmit(formRef)">提交</el-button>
          <el-button @click="cancel">返回</el-button>
        </div>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs, ref } from "vue";
import { Plus } from "@element-plus/icons-vue";
import { communitydutyDetail } from "@/api/communityCare/communityCareApi.js";
import { formatDateYMD } from "@/utils/library/js/util.js";
import { ElMessage } from "element-plus";
import { queryUserList } from "@/api/user.js";
import util from "@util/js";
// import _ from "lodash";
export default defineComponent({
  components: { Plus },
  props: {
    from: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const formRef = ref(null);
    const state = reactive({
      imgURL: window.imgURL,
      token: localStorage.getItem("token"),
      optionsYhList: "",
      userDeptId: util.getStorage("userDeptId"),
      ruleForm: {
        search: "",
        radio: "1",
        fileId: "",
        handleTime: "",
      },
      rules: {
        handleContent: [
          {
            required: true,
            message: "请输入关怀事物",
            trigger: "blur",
          },
        ],
        handleTime: [
          {
            required: true,
            message: "请输入时间信息",
            trigger: "blur",
          },
        ],
        handler: [
          {
            required: true,
            message: "请输入人员信息",
            trigger: "blur",
          },
        ],
        handleRecord: [
          {
            required: true,
            message: "请输入记录",
            trigger: "blur",
          },
        ],
        search: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur",
          },
        ],
      },
    });
    const selectZd = async () => {
      const params = {
        allowpage: true,
        hasSonDept: true,
        deptId: state.userDeptId,
      };
      const ress = await queryUserList(params);
      state.optionsYhList = ress.page.list;
    };
    selectZd();
    const methods = {
      handlePictureCardPreview(file) {
        state.ruleForm.fileId = file.data.fileUrl;
      },
      async onSubmit(formEl) {
        if (!formEl) return;
        formEl.validate(async (valid) => {
          if (valid) {
            const from = JSON.parse(JSON.stringify(state.ruleForm));
            for (const key in from) {
              if (!from[key]) {
                delete from[key];
              }
            }
            from.handleTime = formatDateYMD(from.handleTime);
            from.dutyDetailId = props.from.dutyDetailId;
            const res = await communitydutyDetail(from);
            if (res.code === 0) {
              ElMessage({
                type: "success",
                message: props.formStatus === 1 ? "添加成功" : "修改成功",
              });
              methods.cancel();
            }
          } else {
            console.log("error submit!");
            return false;
          }
        });
      },
      cancel() {
        context.emit("cancel");
      },
    };
    return {
      ...toRefs(state),
      ...methods,
      formRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.formRef {
  width: 100%;
}
.el-form-item {
  width: 100%;
  :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
    font-size: 16px !important;
    .el-icon {
      margin-top: 36px !important;
    }
  }
}
.radio-dc {
  width: 100%;
}
.form-button {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-left: 50px;
}
</style>
